import React from "react";
import { FaCode, FaLinkedin, FaTrophy } from "react-icons/fa";
import { SiCodeforces } from "react-icons/si";
import { Link } from "react-router-dom";
import { useGetMentorsQuery } from "../../features/api/appApi";

const MentorsPage = () => {
  const { data: mentors = [] } = useGetMentorsQuery();

  return (
    <main className="home-shell min-h-screen px-4 pb-14 pt-28 sm:px-6">
      <section className="home-section border-none px-0 py-0">
        <div className="home-container">
          <div className="home-card-strong p-8 sm:p-10">
            <span className="section-kicker">Mentors</span>
            <h1 className="home-title mt-4 text-3xl font-bold sm:text-5xl">Guidance from top competitive programmers.</h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base home-muted">
              Learn directly from mentors with strong contest records, industry impact, and years of practical experience.
            </p>
          </div>
        </div>
      </section>

      <section className="home-section border-none px-0 pb-0 pt-8">
        <div className="home-container grid home-stagger-grid gap-5 lg:grid-cols-2">
          {mentors.map((mentor) => (
            <article key={mentor.id} className="home-card overflow-hidden">
              <div className="relative h-64 w-full overflow-hidden">
                <img src={mentor.imageUrl} alt={mentor.name} className="h-full w-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-5 text-white">
                  <h2 className="text-2xl font-bold">{mentor.name}</h2>
                  <p className="text-sm text-white/90">{mentor.title}</p>
                </div>
              </div>

              <div className="p-5">
                <div className="grid grid-cols-3 gap-2">
                  {(mentor.stats || []).map((stat) => (
                    <div key={stat.label} className="home-card-strong p-3 text-center">
                      <p className="text-[11px] uppercase tracking-wide home-muted">{stat.label}</p>
                      <p className="mt-1 text-sm font-semibold">{stat.value}</p>
                    </div>
                  ))}
                </div>

                <h3 className="mt-5 text-base font-semibold">Highlights</h3>
                <ul className="mt-3 space-y-2">
                  {(mentor.achievements || []).map((achievement) => (
                    <li key={achievement} className="home-card-strong px-3 py-2 text-sm home-muted">
                      {achievement}
                    </li>
                  ))}
                </ul>

                <div className="mt-5 flex flex-wrap gap-2">
                  {mentor.social?.linkedin ? (
                    <a href={mentor.social.linkedin} target="_blank" rel="noreferrer" className="home-btn-secondary inline-flex items-center gap-2 px-4 py-2 text-sm font-medium">
                      <FaLinkedin /> LinkedIn
                    </a>
                  ) : null}
                  {mentor.social?.codeforces ? (
                    <a href={mentor.social.codeforces} target="_blank" rel="noreferrer" className="home-btn-secondary inline-flex items-center gap-2 px-4 py-2 text-sm font-medium">
                      <SiCodeforces /> Codeforces
                    </a>
                  ) : null}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="home-section border-none px-0">
        <div className="home-container">
          <div className="home-card p-8 text-center">
            <div className="mb-3 flex items-center justify-center gap-2 text-sm font-semibold home-muted">
              <FaCode /> <FaTrophy />
            </div>
            <h2 className="text-2xl font-bold">Want direct mentorship?</h2>
            <p className="mx-auto mt-3 max-w-2xl text-sm home-muted">
              Join GUBCPC and participate in regular sessions to get guided contest preparation from our mentors.
            </p>
            <Link to="/join-committee" className="home-btn-primary mt-5 inline-flex px-5 py-3 text-sm font-semibold">
              Join the Community
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MentorsPage;
